import {
  EntryQuestionnaireReqDtoType,
  EntryQuestionnaireHowOldAreYouAnswer,
  EntryQuestionnaireQuestionKey,
} from '@web/common';

export const entryQuestionnaireEvaluation = (
  questionnaire: EntryQuestionnaireReqDtoType,
) => {
  if (
    questionnaire[EntryQuestionnaireQuestionKey.HOW_OLD_ARE_YOU] ===
    EntryQuestionnaireHowOldAreYouAnswer.UNDER_18
  ) {
    return false;
  }

  return true;
};
